<template>
  <div>
    <van-list
      class="goodsList"
      v-model="loading"
      :finished="finished"
      @load="onLoad"
    >
      <router-link
        :to="'/qiang/detail/'+item.id"
        class="item"
        v-for="item in goodsList"
        :key="item.id"
      >
        <van-tag class="huodongTag" v-if="item.goods_level==1" round type="danger">活动</van-tag>
        <div class="left">
          <van-image
            class="thumbnail"
            width="100"
            height="100"
            fit="cover"
            radius="10px"
            :src="GLOBAL.IMG + item.thumbnail"
          />
        </div>
        <div class="right">
          <div class="title">{{item.post_title}}</div>
          <div style="display:flex;justify-content: space-between; margin-top:6px">
            <div class="price"><em>¥ {{item.price}}</em> <em  style="text-decoration:line-through;font-size:14px;  color:#1baeae"> ¥{{item.yprice}}</em></div>
            <div><van-button round  size="mini" color="#1baeae">马上抢</van-button></div>
            <!-- #FF6634 -->
          </div>
          <div class="timer">
              <van-count-down
                :time="item.end_time*1000 - Date.parse(new Date())"
                format="DD天HH时mm分ss秒"
              />
            </div>
        </div>
      </router-link>
    </van-list>
  </div>
</template>
<script>
import Vue from "vue";
import { CountDown } from "vant";

Vue.use(CountDown);
export default {
  name: "qiangList",
  data() {
    return {
      goodsList: [],
      loading: false,
      finished: false,
      cPage: 1
    };
  },
  methods: {
    onLoad() {
      this.$http
        .get(this.GLOBAL.API + "s_qiang/goods/tuiList", {
          params: { cid: 1, page: this.cPage },
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          this.loading = false;
          if (this.cPage >= data.data.last_page) {
            this.finished = true;
          } else {    
            this.cPage++;
          }
          if (data.code == 1) {
            this.goodsList = this.goodsList.concat(data.data.data); //= data.data.data;
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.goodsList {
  text-align: left;
  //background-color: #fff;
  .item {
    display: flex;
    background-color: #fff;
    //background: linear-gradient(to right,#1baeae,#1baeae,#1baeae);
    //background: linear-gradient(to right,#780001,#d3512f,#780001);
    //background: linear-gradient(to right,#CBC9CC,#CBC9CC,#CBC9CC);
    padding: 10px 10px 0 10px;
    margin-top: 7px;
    position: relative;
    .huodongTag{
        position: absolute;
        z-index: 999;
        top:0;
        right:0;
    }
    .left {
      width: 100px;
      img {
        width: 100px;
      }
    }

    .right {
      padding-left: 10px;
      width:100%;
      color: #fff;
      .title {
        line-height: 25px;
        height: 50px;
        overflow: hidden;
        padding: 0 5px 0 5px;
        // color: #333;
        color: #222333;
        //color: #1baeae;
      }
      .price {
        text-align: left;
        padding: 0 5px 0 5px;
        line-height: 20px;
        //color: #fff;
        color: #1baeae;
        //color: #c02c38;
        font-size: 16px;
      }
      .timer {
        padding-left: 5px;
        .van-count-down {
          // color: #e01222;
          //color: #222333;
          color: #1baeae;
          //color: #c02c38;
          //color: #fff;
          font-weight: 500;
        }
      }
    }
  }
}
</style>